import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { attachReducer } from "@redux-dynostore/redux-subspace";
import React, { useCallback, useEffect, useState, useMemo } from "react";
import { connect } from "react-redux";

import styled, { withTheme } from "styled-components";

import moment from "moment";

import SmartFoodDrinkSelector from "../FoodDrinkSelector/FoodDrinkSelector";
import SmartDietDiaryCharts from "../Charts/DietDiaryCharts";
import DateAndTime from "../DateAndTime/DateAndTime/DateAndTime";
import CustomTabs, {
  CustomTabContent,
  TabButton,
} from "../../ui-library/CustomTabs/CustomTabs";

import NutritionTable from "../../library/NutritionTable/NutritionTable";
import FrequentlyForgottenItems from "../../library/FrequentlyForgottenItems/FrequentlyForgottenItems";
import { sendNotification } from "../../ToastManager/ToastManager";
import { ToastType } from "../../ToastManager/constants";

import AnimatedButton from "../../ui-library/Buttons/AnimatedButton/AnimatedButton";
import SecondaryButton from "../../ui-library/Buttons/SecondaryButton/SecondaryButton";
import PrimaryButton from "../../ui-library/Buttons/PrimaryButton/PrimaryButton";

import {
  dietDiaryReducer,
  mapDispatchToProps,
  mapStateToProps,
} from "./DietDiary.store";
import Favorite from "../../ui-library/Favorite/Favorite";
import DailyTargets from "../../library/Goals/DailyTargets";
import LabelledInput from "../../ui-library/LabelledInput/LabelledInput";
import Checkbox from "../../ui-library/Checkbox/Checkbox";
import {
  ADMINISTERED_BY_OPTIONS,
  DietDairyTypes,
  dietDairyTypeToString,
  FEEDING_TYPE_OPTIONS,
} from "./DietDiary.constants";
import { scrollModalToTop } from "../../../modules/utils";
import {
  dailyTargetIds,
  DateFormat,
  DEFAULT_REASON_FOR_CHANGE,
  getMacronutrientColor,
  noDateDefinedOrEmpty,
  PIE_CHART_SERIES_ATTRS,
  UNIT,
} from "../../../modules/constants";
import { useTranslation } from "react-i18next";
import {
  addOtherSlice,
  calcKcalByAttrId,
  decimalPlaces,
  roundMealValue,
  roundMealPercentage,
  generateAboutMeal,
  UNKNOWN_NUTRIENT_VALUE,
} from "../../../helpers/mealsHelper";
import CustomDropdown from "../../ui-library/CustomDropdown/CustomDropdown";
import DateStartEndTime from "../DateAndTime/DateStartEndTime/DateStartEndTime";
import { DEFAULT_MOMENT_LOCALE, isRtl } from "../../../i18n/helpers";

const ActionButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 38px;

  @media (max-width: 991px) {
    margin-top: 1rem;
    justify-content: space-between;
    & > button {
      width: 100%;
    }
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  flex-wrap: wrap;
`;

const LeftColWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;

  @media (max-width: 991px) {
    width: 100%;
  }
`;

const RightColWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  padding-left: 25px;
  margin-top: 0;

  @media (max-width: 991px) {
    width: 100%;
    padding-left: 0;
    margin-top: 30px;
  }
`;

const AdministrationMethodWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const AdministrationMethodRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 15px;
`;

const DateAndTimeRowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 15px;
`;

const FavoriteWrapper = styled.div`
  margin-top: 25px;
`;

const DailyTargetsWrapper = styled.div`
  margin-top: 20px;
`;

const ReasonForChangeWrapper = styled.div`
  margin-top: 25px;
`;

const StyledCheckboxLabel = styled.div`
  font-weight: 600;
  margin-left: 15px;
  cursor: pointer;
`;

const StyledCheckboxWrapper = styled.div`
  display: flex;
  margin-top: 30px;
  margin-bottom: 15px;
`;

const FieldTitle = styled.span`
  color: ${(props) => props.theme?.nero};
  font-weight: 600;
  font-size: 16px;
`;

export const SmartDietDiary = (props) => {
  const {
    dailyTargets,
    nutritionalInfo,
    setNutritionalInfo,
    selectedItems,
    setSelectedItems,
    calories,
    setCalories,
    chartsHelper,
    setChartsHelper,
    isSuccess,
    isError,
    setIsSuccess,
    setIsError,
    dateAndTimeValues,
    setDateAndTimeValues,
    saveDietDiaryMeal,
    nutritionFields,
    fetchNutritionFields,
    setAboutMeal,
    aboutMeal,
    updateReasonFor,
    setUpdateReasonFor,
    resetStates,
    defaultItems,
    mealId,
    onSubmit,
    mealJsonData,
    existingReasonForChange,
    minDate,
    maxDate,
    participantId,
    type,
    mealDate,
    mealEndDate,
    readOnly,
    setModalTitle,
    dietDiaryOption,
    theme,
    canAddNoteMealLog,
    canCreateFavorites,
    baseFavoriteMealId,
    onClose,
    mealAdministeredBy,
    mealFeedingType,
    is24hRecall,
    isPaperRecapture,
    participantLanguage,
    fetchParticipantTimeFormat,
    participantTimeFormat,
  } = props;

  const { t } = useTranslation();

  const [updateReasonForIsValid, setUpdateReasonForIsValid] = useState(false);

  const [favoriteName, setFavoriteName] = useState("");
  const [addToFavorites, setAddToFavorites] = useState(false);
  const [favoriteNameIsValid, setFavoriteNameIsValid] = useState(false);
  const [favoriteNameError, setFavoriteNameError] = useState(null);

  const [confirm, setConfirm] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [confirmingItems, setConfirmingItems] = useState(false);
  const [dateTimeError, setDateTimeError] = useState(false);
  const [reasonForChangeError, setReasonForChangeError] = useState(null);

  const [administeredByOption, setAdministeredByOption] = useState(null);
  const [feedingTypeOption, setFeedingTypeOption] = useState(null);

  const [tabActiveKey, setTabActiveKey] = useState("first");

  const btnSaveErrorMngmt = {
    isSuccess: isSuccess,
    setIsSuccess: setIsSuccess,
    isError: isError,
    setIsError: setIsError,
  };

  const handleConfirm = () => {
    if (!selectedItems || selectedItems.length === 0) {
      setIsError(true);
      sendNotification(
        t("errorText.dietDiary.addMeal.noItems"),
        ToastType.ERROR
      );
      return;
    }

    const anyItemWithoutQty = selectedItems.some(
      (item) => !item.qty || parseFloat(item.qty) === 0
    );
    if (anyItemWithoutQty) {
      setIsError(true);
      sendNotification(
        t("errorText.dietDiary.addMeal.noQuantities"),
        ToastType.ERROR
      );
      return;
    }

    if (confirmingItems) {
      submitHandler();
    } else {
      scrollModalToTop();
      setConfirmingItems(true);
    }
  };

  useEffect(() => {
    if (setModalTitle && dietDiaryOption) {
      if (confirmingItems) {
        setModalTitle(t("appText.dietDiary.addMeal.confirm.title"));
      } else {
        if (mealId && readOnly) {
          setModalTitle(
            `${t("appText.view")} ${dietDairyTypeToString(
              dietDiaryOption.type
            )}`
          );
        } else if (mealId && !readOnly) {
          setModalTitle(
            `${t("appText.edit")} ${dietDairyTypeToString(
              dietDiaryOption.type
            )}`
          );
        } else {
          setModalTitle(
            `${t("appText.add")} ${dietDairyTypeToString(dietDiaryOption.type)}`
          );
        }
      }
    }
  }, [confirmingItems, dietDiaryOption, mealId, readOnly, setModalTitle, t]);

  useEffect(() => {
    if (participantId) {
      fetchParticipantTimeFormat(participantId);
    }
  }, [participantId, fetchParticipantTimeFormat]);

  const getNutrientById = useCallback(
    (searchAttrId) => {
      const info = nutritionalInfo.find(
        ({ attr_id }) => attr_id === searchAttrId
      );

      return info;
    },
    [nutritionalInfo]
  );

  const getNutrientUnitById = useCallback(
    (searchAttrId) => {
      const info = getNutrientById(searchAttrId);

      return info ? info.unit : "";
    },
    [getNutrientById]
  );

  const dailyTargetsArr = useMemo(() => {
    return {
      isRtl: isRtl(),
      goalTitle: t("appText.dietDiary.dailyTargets"),
      goalsList: [
        {
          goalLabel: t("appText.dietDiary.longChainFats"),
          goalColor: getMacronutrientColor(
            dailyTargetIds.LONG_CHAIN_FATS_ATTR_ID,
            theme
          ),
          goalValue: `${roundMealValue(
            dailyTargets?.longChainFatsPercentage ?? 0
          )}${UNIT.PERCENTAGE}`,
        },
        {
          goalLabel: t("appText.dietDiary.mediumChainFats"),
          goalColor: getMacronutrientColor(
            dailyTargetIds.MEDIUM_CHAIN_FATS_ATTR_ID,
            theme
          ),
          goalValue: `${roundMealValue(
            dailyTargets?.mediumChainFatsPercentage ?? 0
          )}${UNIT.PERCENTAGE}`,
        },
        {
          goalLabel: t("appText.dietDiary.protein"),
          goalColor: getMacronutrientColor(
            dailyTargetIds.PROTEIN_ATTR_ID,
            theme
          ),
          goalValue: `${roundMealValue(dailyTargets?.proteinPercentage ?? 0)}${
            UNIT.PERCENTAGE
          }`,
        },
        {
          goalLabel: t("appText.dietDiary.carbohydrates"),
          goalColor: getMacronutrientColor(dailyTargetIds.CARBS_ATTR_ID, theme),
          goalValue: `${roundMealValue(
            dailyTargets?.carbohydratesPercentage ?? 0
          )}${UNIT.PERCENTAGE}`,
        },
      ],
    };
  }, [dailyTargets, theme, t]);

  const setupChartsHelper = useCallback(() => {
    const chartInfoVals = PIE_CHART_SERIES_ATTRS.map((searchAttrId) => {
      const nutrient = nutritionalInfo.find(
        ({ attr_id }) => attr_id === searchAttrId
      );
      const numericValue = nutrient?.numericValue ?? 0.0;
      const title = nutrient
        ? isRtl()
          ? t(nutrient.translationId)
          : nutrient.chartTitle
        : "";
      const aboutMealLetter = nutrient ? nutrient.aboutMealLetter : "";
      const value = nutrient ? nutrient.value : UNKNOWN_NUTRIENT_VALUE;
      const unit = nutrient?.unit ?? "";

      return {
        attr_id: searchAttrId,
        letter: title,
        aboutMealLetter: aboutMealLetter,
        numericValue: numericValue,
        value: value === UNKNOWN_NUTRIENT_VALUE ? `0.0${unit}` : value,
      };
    });

    const total = calories.numericValue || 1;

    const tmpImpactVals = {};
    const chartVals = chartInfoVals.map((item) => {
      const frequency = roundMealPercentage(
        roundMealValue(
          (calcKcalByAttrId(item.numericValue, item.attr_id) / total) * 100.0
        )
      );

      tmpImpactVals[item.aboutMealLetter] = {
        value: item.numericValue,
        percentage: frequency,
        unit: getNutrientUnitById(item.attr_id),
      };

      const percentage = `${Number(frequency).toFixed(decimalPlaces)}${
        UNIT.PERCENTAGE
      }`;

      return {
        letter: item.letter,
        frequency: frequency,
        color: getMacronutrientColor(item.attr_id, theme),
        percentage: percentage,
        info: `${percentage} - ${item.value}`,
        isVisible: true,
      };
    });

    chartVals && chartVals.push(addOtherSlice(chartVals, theme, t));

    setChartsHelper({
      pieChartSeries: chartVals,
      hpbcImpact: tmpImpactVals,
    });

    setAboutMeal(generateAboutMeal(nutritionalInfo, total));
  }, [
    nutritionalInfo,
    setChartsHelper,
    setAboutMeal,
    getNutrientUnitById,
    theme,
    calories.numericValue,
    t,
  ]);

  useEffect(() => {
    const tmpCalories = nutritionalInfo.find(
      ({ attr_id }) => attr_id === dailyTargetIds.CALORIES_ATTR_ID
    );
    if (tmpCalories) {
      const normalizedValue = roundMealValue(tmpCalories.numericValue);

      setCalories({
        percentage: 0,
        value: `${normalizedValue.toFixed(decimalPlaces)}${tmpCalories.unit}`,
        numericValue: tmpCalories.numericValue,
        unit: getNutrientUnitById(dailyTargetIds.CALORIES_ATTR_ID),
      });
    }

    setupChartsHelper();
  }, [nutritionalInfo, setCalories, setupChartsHelper, getNutrientUnitById]);

  useEffect(() => {
    setFavoriteNameIsValid(
      favoriteName.replace(/\.|,/g, "").trim() !== "" &&
        favoriteName.length <= 512
    );
  }, [favoriteName]);

  useEffect(() => {
    setUpdateReasonForIsValid(
      updateReasonFor.replace(/\.|,/g, "").trim() !== "" &&
        updateReasonFor.length <= 450
    );
  }, [updateReasonFor]);

  const backHandler = () => {
    scrollModalToTop();
    setConfirm(false);
    setConfirmingItems(false);
  };

  const validateFavoriteName = (name) => {
    setFavoriteNameError(null);
    if (name.replace(/\.|,/g, "").trim() === "") {
      setFavoriteNameError(t("errorText.dietDiary.addFavorite.empty.name"));
    }
    if (name.length > 512) {
      setFavoriteNameError(t("errorText.dietDiary.addFavorite.large.name"));
    }
  };

  const validateReasonForChange = (reason) => {
    setReasonForChangeError(null);
    if (reason.replace(/\.|,/g, "").trim() === "") {
      setReasonForChangeError("Please provide a reason");
    }
    if (reason.length > 450) {
      setReasonForChangeError(
        "Please enter a reason with less than 450 characters"
      );
    }
  };

  const submitHandler = useCallback(() => {
    const date = moment(dateAndTimeValues.dateAndTimeObj.date);
    const startTime = moment(dateAndTimeValues.dateAndTimeObj.startTime)
      .locale(DEFAULT_MOMENT_LOCALE)
      .format("HH:mm")
      .split(":");
    date.set({
      h: startTime[0],
      m: startTime[1],
    });

    const tmpAboutMeal = aboutMeal;

    tmpAboutMeal["Calories"] = {
      percentage: 0,
      value: calories.numericValue,
      unit: calories.unit,
    };

    const mealJson = {
      aboutMeal: tmpAboutMeal,
      items: selectedItems,
      type: type,
    };

    let formData = {
      mealDate: date
        .locale(DEFAULT_MOMENT_LOCALE)
        .format(DateFormat.EXTENDED_DATETIME),
      mealJson: JSON.stringify(mealJson),
      administeredBy: administeredByOption?.id,
    };

    if (is24hRecall) {
      formData.recall = is24hRecall;
      formData.reason = DEFAULT_REASON_FOR_CHANGE["24HourRecall"];
    }

    if (isPaperRecapture) {
      formData.paperRecapture = isPaperRecapture;
      formData.reason = DEFAULT_REASON_FOR_CHANGE.paperRecapture;
    }

    if (administeredByOption?.feedingTypeRequired) {
      formData.feedingType = feedingTypeOption?.id;

      if (feedingTypeOption?.startEndTimeRequired) {
        const endDate = moment(dateAndTimeValues.dateAndTimeObj.date);
        const endTime = moment(dateAndTimeValues.dateAndTimeObj.endTime)
          .locale(DEFAULT_MOMENT_LOCALE)
          .format("HH:mm")
          .split(":");
        endDate.set({
          h: endTime[0],
          m: endTime[1],
        });

        formData.mealEndDate = endDate
          .locale(DEFAULT_MOMENT_LOCALE)
          .format(DateFormat.EXTENDED_DATETIME);
      }
    }

    if (canCreateFavorites && !mealId) {
      if (addToFavorites) {
        if (favoriteNameIsValid) {
          formData.isFavorite = addToFavorites;
          formData.favoriteName = favoriteName;
        } else {
          setFavoriteNameIsValid(false);
          setIsError(true);
          return;
        }
      }
    }

    if (participantId) {
      formData.participantId = participantId;
    }

    if (mealId) {
      formData.mealID = mealId;

      if (canAddNoteMealLog) {
        if (updateReasonForIsValid) {
          formData.reasonForChange = updateReasonFor;
        } else {
          setUpdateReasonForIsValid(false);
          setIsError(true);
          return;
        }
      } else {
        formData.reasonForChange = "Participant edited entry";
      }
    }

    saveDietDiaryMeal(formData, mealId)
      .then((message) => {
        sendNotification(message, ToastType.SUCCESS);
        setIsSuccess(true);
        resetStates();
        onSubmit();
      })
      .catch((error) => {
        sendNotification(error, ToastType.ERROR);
        setIsError(true);
      });
  }, [
    dateAndTimeValues,
    aboutMeal,
    calories,
    selectedItems,
    type,
    canCreateFavorites,
    mealId,
    participantId,
    canAddNoteMealLog,
    saveDietDiaryMeal,
    addToFavorites,
    favoriteNameIsValid,
    favoriteName,
    setIsError,
    updateReasonForIsValid,
    updateReasonFor,
    setIsSuccess,
    resetStates,
    onSubmit,
    administeredByOption,
    feedingTypeOption,
  ]);

  useEffect(() => {
    resetStates();
  }, []);

  useEffect(() => {
    setStartDate(dateAndTimeValues?.dateAndTimeObj?.date || new Date());
  }, [dateAndTimeValues]);

  useEffect(() => {
    if (mealJsonData) {
      const mealData = JSON.parse(mealJsonData);
      setAboutMeal(mealData?.aboutMeal);
      setSelectedItems(mealData?.items);
    }
  }, [mealJsonData, setAboutMeal, setSelectedItems]);

  useEffect(() => {
    if (existingReasonForChange) {
      setUpdateReasonFor(existingReasonForChange);
    }
  }, [existingReasonForChange, setUpdateReasonFor]);

  const onChangeDate = useCallback(
    (isDateAndTimeValid, dateAndTimeObj) => {
      setDateAndTimeValues({
        isValid: isDateAndTimeValid,
        dateAndTimeObj,
      });
    },
    [setDateAndTimeValues]
  );

  useEffect(() => {
    if (mealDate) {
      onChangeDate(true, {
        date: moment(mealDate).toDate(),
        startTime: moment(mealDate).toDate(),
        endTime: moment(
          mealEndDate === noDateDefinedOrEmpty ? new Date() : mealEndDate
        ).toDate(),
      });
    }
  }, [mealDate, mealEndDate, onChangeDate]);

  const handleKeyPressCheckbox = (e) => {
    if (e.key === "Enter") {
      setConfirm((prevState) => !prevState);
    }
  };

  const tableHeaders = [
    { label: t("appText.description") },
    { label: t("appText.quantity") },
  ];

  const administeredByOptions = useMemo(
    () =>
      Object.values(ADMINISTERED_BY_OPTIONS).map((options) => ({
        ...options,
        value: t(options.translationId),
      })),
    []
  );

  const feedingTypeOptions = useMemo(
    () =>
      Object.values(FEEDING_TYPE_OPTIONS).map((options) => ({
        ...options,
        value: t(options.translationId),
      })),
    []
  );

  useEffect(() => {
    if (mealAdministeredBy) {
      setAdministeredByOption(
        administeredByOptions.find((option) => option.id === mealAdministeredBy)
      );
    } else {
      setAdministeredByOption(
        administeredByOptions.find(
          (option) => option.id === ADMINISTERED_BY_OPTIONS.MOUTH.id
        )
      );
    }
  }, [mealAdministeredBy, administeredByOptions]);

  useEffect(() => {
    if (mealFeedingType) {
      setFeedingTypeOption(
        feedingTypeOptions.find((option) => option.id === mealFeedingType)
      );
    } else {
      setFeedingTypeOption(
        feedingTypeOptions.find(
          (option) => option.id === FEEDING_TYPE_OPTIONS.CONTINUOUS.id
        )
      );
    }
  }, [mealFeedingType, feedingTypeOptions]);

  const isNextButtonDisabled = useMemo(() => {
    return (
      (canAddNoteMealLog && mealId && !updateReasonForIsValid) ||
      dateTimeError ||
      (canCreateFavorites &&
        !mealId &&
        addToFavorites &&
        !favoriteNameIsValid) ||
      ((!defaultItems || defaultItems.length > 0) &&
        (!selectedItems || selectedItems.length === 0)) ||
      (administeredByOption?.feedingTypeRequired &&
        feedingTypeOption?.startEndTimeRequired &&
        (!dateAndTimeValues?.dateAndTimeObj?.date ||
          !dateAndTimeValues?.dateAndTimeObj?.startTime ||
          !dateAndTimeValues?.dateAndTimeObj?.endTime ||
          dateAndTimeValues?.dateAndTimeObj?.startTime >
            dateAndTimeValues?.dateAndTimeObj?.endTime)) ||
      !dateAndTimeValues?.dateAndTimeObj?.date ||
      !dateAndTimeValues?.dateAndTimeObj?.startTime
    );
  }, [
    canAddNoteMealLog,
    mealId,
    updateReasonForIsValid,
    dateTimeError,
    addToFavorites,
    favoriteNameIsValid,
    defaultItems,
    selectedItems,
    dateAndTimeValues,
    administeredByOption,
    feedingTypeOption,
  ]);

  return (
    <Container data-testid="diet-diary">
      <Row>
        <LeftColWrapper>
          <SmartFoodDrinkSelector
            defaultItems={defaultItems}
            selectedItems={selectedItems}
            setSelectedItems={setSelectedItems}
            readOnly={confirmingItems || readOnly}
            title={t("appText.dietDiary.addMeal.confirm.myItems")}
            inputTitle={
              type === DietDairyTypes.FOOD_DRINK
                ? t("appText.dietDiary.addMeal.search.label.foodAndDrink")
                : t("appText.dietDiary.addMeal.search.label")
            }
            participantLanguage={participantLanguage}
          />

          <AdministrationMethodWrapper>
            <AdministrationMethodRow>
              <FieldTitle className="me-2">
                {t("appText.dietDiary.administeredBy.label")}
              </FieldTitle>
              <CustomDropdown
                data-testid="administered-by-dropdown"
                defaultValue={administeredByOptions[0].value}
                value={administeredByOption?.value}
                disabled={confirmingItems || readOnly}
                options={administeredByOptions}
                width={145}
                onChange={(value) => setAdministeredByOption(value)}
                limitheight={true}
                align={isRtl() ? "end" : "start"}
              />
            </AdministrationMethodRow>

            {administeredByOption?.feedingTypeRequired && (
              <AdministrationMethodRow>
                <FieldTitle className="me-2">
                  {t("appText.dietDiary.feedingType.label")}
                </FieldTitle>
                <CustomDropdown
                  data-testid="feeding-type-dropdown"
                  defaultValue={feedingTypeOptions[0].value}
                  value={feedingTypeOption?.value}
                  disabled={confirmingItems || readOnly}
                  options={feedingTypeOptions}
                  width={145}
                  onChange={(value) => setFeedingTypeOption(value)}
                  limitheight={true}
                  align={isRtl() ? "end" : "start"}
                />
              </AdministrationMethodRow>
            )}
          </AdministrationMethodWrapper>

          <DateAndTimeRowWrapper>
            {administeredByOption?.feedingTypeRequired &&
            feedingTypeOption?.startEndTimeRequired ? (
              <DateStartEndTime
                maxDate={maxDate}
                minDate={minDate}
                onChange={onChangeDate}
                readOnly={confirmingItems || readOnly}
                defaultDate={dateAndTimeValues?.dateAndTimeObj?.date}
                defaultStartTime={dateAndTimeValues?.dateAndTimeObj?.startTime}
                defaultEndTime={dateAndTimeValues?.dateAndTimeObj?.endTime}
                onError={setDateTimeError}
                timeIntervals={5}
                timeFormat={participantTimeFormat}
              />
            ) : (
              <DateAndTime
                onChange={onChangeDate}
                maxDate={maxDate}
                minDate={minDate}
                readOnly={confirmingItems || readOnly}
                defaultDate={dateAndTimeValues?.dateAndTimeObj?.date}
                defaultTime={dateAndTimeValues?.dateAndTimeObj?.startTime}
                onError={setDateTimeError}
                timeIntervals={5}
                dateClassName="date-select-wrapper me-4"
                timeClassName="time-wrapper"
                timeFormat={participantTimeFormat}
              />
            )}
          </DateAndTimeRowWrapper>

          {dailyTargetsArr && (
            <DailyTargetsWrapper>
              <DailyTargets {...dailyTargetsArr} />
            </DailyTargetsWrapper>
          )}
        </LeftColWrapper>
        <RightColWrapper>
          {confirmingItems ? (
            <FrequentlyForgottenItems dietDiaryType={type} />
          ) : (
            <CustomTabs
              defaultActiveKey="first"
              onSelect={(eventKey) => {
                setTabActiveKey(eventKey);
              }}
            >
              <TabButton eventKey="first" data-testid="about-meal-tab">
                {t("appText.dietDiary.addMeal.aboutMeal")}
              </TabButton>
              <TabButton eventKey="second" data-testid="nutrition-details-tab">
                {t("appText.dietDiary.addMeal.nutritionDetails")}
              </TabButton>
              <CustomTabContent eventKey="first">
                <SmartDietDiaryCharts
                  participantId={participantId}
                  getNutrientById={getNutrientById}
                  calories={calories}
                  pieChartSeries={chartsHelper.pieChartSeries}
                  hpbcImpact={
                    selectedItems.length > 0 ? chartsHelper.hpbcImpact : null
                  }
                  startDate={startDate}
                  getMacronutrientColor={getMacronutrientColor}
                  mealId={mealId}
                  rerenderPieChart={tabActiveKey === "first"}
                />
              </CustomTabContent>
              <CustomTabContent eventKey="second">
                <NutritionTable
                  nutritionalInfo={nutritionalInfo}
                  setNutritionalInfo={setNutritionalInfo}
                  nutritionFields={nutritionFields}
                  fetchNutritionFields={fetchNutritionFields}
                  selectedItems={selectedItems}
                  tableHeaders={tableHeaders}
                />
              </CustomTabContent>
            </CustomTabs>
          )}

          {canCreateFavorites &&
            !baseFavoriteMealId &&
            !mealId &&
            !confirmingItems && (
              <FavoriteWrapper>
                <Favorite
                  defaultIsFavorite={addToFavorites}
                  defaultFavoriteName={favoriteName}
                  onChangeIsFavorite={setAddToFavorites}
                  onChangeFavoriteName={setFavoriteName}
                  onBlur={(e) => validateFavoriteName(e.target.value)}
                  hasError={!!favoriteNameError}
                  errorMessage={favoriteNameError}
                />
              </FavoriteWrapper>
            )}

          {canAddNoteMealLog && mealId && readOnly && updateReasonFor && (
            <ReasonForChangeWrapper>
              <LabelledInput
                title="Reason for change"
                type="text"
                data-testid="update-reason-input"
                value={updateReasonFor}
                disabled={true}
              />
            </ReasonForChangeWrapper>
          )}

          {mealId && !confirmingItems && !readOnly && canAddNoteMealLog && (
            <ReasonForChangeWrapper>
              <LabelledInput
                title="Reason for change"
                type="text"
                data-testid="update-reason-input"
                onBlur={(e) => validateReasonForChange(e.target.value)}
                hasError={!!reasonForChangeError}
                errorMessage={reasonForChangeError}
                value={updateReasonFor}
                onChange={(e) => setUpdateReasonFor(e.target.value)}
              />
            </ReasonForChangeWrapper>
          )}

          {confirmingItems && !readOnly && (
            <StyledCheckboxWrapper
              tabIndex="0"
              onKeyPress={handleKeyPressCheckbox}
            >
              <Checkbox
                data-testid="confirm-checkbox"
                checked={confirm}
                onClick={() => setConfirm((prevState) => !prevState)}
                icon={true}
                square={true}
              />
              <StyledCheckboxLabel
                data-testid="confirm-checkbox-label"
                onClick={() => setConfirm((prevState) => !prevState)}
              >
                {t("appText.dietDiary.addMeal.confirm.label")}
              </StyledCheckboxLabel>
            </StyledCheckboxWrapper>
          )}
        </RightColWrapper>
      </Row>

      {dietDiaryOption && (
        <ActionButtonsContainer>
          {confirmingItems && (
            <SecondaryButton
              data-testid="back-button"
              className="me-3"
              onClick={() => backHandler()}
            >
              {t("appText.back")}
            </SecondaryButton>
          )}

          {readOnly && (
            <PrimaryButton data-testid="close-button" onClick={() => onClose()}>
              {t("appText.close")}
            </PrimaryButton>
          )}

          {readOnly ? (
            <div></div>
          ) : confirmingItems ? (
            <AnimatedButton
              data-testid="submit-button"
              icon={null}
              onClick={() => handleConfirm()}
              disabled={!confirm}
              keepBorder={true}
              {...btnSaveErrorMngmt}
            >
              {t("appText.submit")}
            </AnimatedButton>
          ) : (
            <PrimaryButton
              data-testid="next-button"
              disabled={isNextButtonDisabled}
              onClick={() => handleConfirm()}
            >
              {t("appText.next")}
            </PrimaryButton>
          )}
        </ActionButtonsContainer>
      )}
    </Container>
  );
};

const combineMapStateToProps = (state) => {
  return {
    ...state,
    ...mapStateToProps(state),
  };
};

export default dynamic(
  "dietDiaryReducer",
  subspaced({
    // We map extra state because we might need to acess other stores for data, subspace is self contained.
    mapExtraState: (state) => {
      return {
        loginReducer: state.loginReducer,
        dietDiaryChartsReducer: state.dietDiaryReducer.dietDiaryChartsReducer,
        smartPageHeaderReducer: state.smartPageHeaderReducer,
      };
    },
  }),
  attachReducer(dietDiaryReducer)
)(
  connect(combineMapStateToProps, mapDispatchToProps)(withTheme(SmartDietDiary))
);
